import { render } from "./ExpedientsListAddModal.vue?vue&type=template&id=6b846e1d"
import script from "./ExpedientsListAddModal.vue?vue&type=script&lang=js"
export * from "./ExpedientsListAddModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__